module.exports = __webpack_public_path__ + "img/icon-point@2x.ddf269e8.png";